import React, { Component } from "react";

import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import {
  IconButton,
  Typography,
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

// // Shared layouts
import ClearIcon from "@material-ui/icons/Clear";

// Component styles
import styles from "./styles";
import { createNewIntents } from "../../redux/actions/intentsActions";
import Drawer from "@material-ui/core/Drawer";

import _ from "lodash";
import defaultSlotTypes from "./SlotsWithBusinessDescriptionFallback";

class EditIntent extends Component {
  state = {
    editOpen: false
  };

  onCloseClick = () => {
    this.props.onClose(false);
  };
  async createIntent() {
    await this.props.createNewIntents(this.props.intent.ID);
    console.log(this.props.intentCreated);
    if (this.props.intentCreated) {
      console.log("CREATED");
      this.props.onClose(true);
    } else {
      console.log("NOT");
    }
  }

  onCreateIntent = () => {
    this.createIntent();
  };

  getBusinessSlotName = slot => {
    let foundDesc = null;
    defaultSlotTypes.BuiltInSlot.forEach(function(defaultSlot) {
      if (defaultSlot.SlotType === slot) {
        foundDesc = defaultSlot.BusinessDescription;
      }
    });

    return foundDesc ? foundDesc : slot;
  };

  displayUtterance() {
    const { intent, classes } = this.props;
    if (!intent["utterances"]) {
      return (
        <React.Fragment>
          <Typography className={classes.connectorTitle} variant="h6">
            No Examples
          </Typography>
        </React.Fragment>
      );
    }
    const utterances = _.get(intent, "exampleUtterances", _.get(intent, "utterances"))
      .trim()
      .replace("\r\n", "\n")
      .split("\n")
      .map(function(line) {
        return line.trim();
      })
      // Ignore empty lines and comments
      .filter(function(line) {
        // return line.length > 0 && line[0] !== '#';
        return line.length > 0;
      });

    return (
      <React.Fragment>
        <Box className={classes.intentDetailsBox}>
          <Typography variant="h5">Utterances</Typography>
        </Box>
        <List dense={true} component="nav" className={classes.utterancesList}>
          {utterances.map((value, index) => (
            <ListItem key={index}>
              <ListItemText primary={value} />
            </ListItem>
          ))}
        </List>
      </React.Fragment>
    );
  }

  displayParameters() {
    const { intent, classes } = this.props;

    if (!intent["slots"] || intent["slots"].length === 0) {
      return (
        <React.Fragment>
          <Typography className={classes.connectorTitle} variant="h6">
            No Parameters
          </Typography>
        </React.Fragment>
      );
    }
    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {intent.slots.map((slot, index) => (
            <TableRow key={1000 + index}>
              <TableCell>{slot.name}</TableCell>
              <TableCell>{_.get(slot, "slotBusinessDesc", this.getBusinessSlotName(slot.type))}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  render() {
    const { classes, open, intent, showCreateButton } = this.props;

    if (!open) {
      return <React.Fragment />;
    }
    return (
      <Drawer anchor="right" open={open} variant="persistent" classes={{ paper: classes.editRightSide }}>
        <div style={{ paddingTop: "80px" }}>
          <IconButton color="primary" onClick={this.onCloseClick}>
            <ClearIcon />
          </IconButton>
        </div>
        <div style={{ overflowY: "auto" }}>
          <div className={classes.intentDetailsBox}>
            <div className={classes.editTitleRow}>
              <Typography className={classes.title} variant="h3">
                {intent.title}
              </Typography>
            </div>
            <Divider />
            {intent.desc ? (
              <React.Fragment>
                <Typography variant="subtitle2" className={classes.subtitle}>
                  Description:
                </Typography>
                <Typography variant="h5" className={classes.intentDetails}>
                  {intent.desc}
                </Typography>
              </React.Fragment>
            ) : (
              ""
            )}
            <Typography variant="subtitle2" className={classes.subtitle}>
              ID:
            </Typography>
            <Typography variant="h5" className={classes.intentDetails}>
              {intent.name}
            </Typography>
          </div>
          <Divider className={classes.divider} />
          {this.displayUtterance()}
          <Divider className={classes.divider} />
          <div className={classes.intentDetailsBox}>
            <Typography variant="h5">Parameters</Typography>
            {this.displayParameters()}
          </div>
          {showCreateButton ? (
            <Button
              variant="contained"
              size="large"
              color="primary"
              className={classes.margin}
              onClick={this.onCreateIntent}
            >
              Add Task
            </Button>
          ) : (
            <React.Fragment />
          )}
        </div>
      </Drawer>
    );
  }
}

EditIntent.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  intent: PropTypes.object,
  intentCreated: PropTypes.bool,
  createNewIntents: PropTypes.func,
  showCreateButton: PropTypes.bool
};

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        createNewIntents
      },
      dispatch
    ),
    dispatch
  };
}

function mapStateToProps(state) {
  return {
    intentCreated: state.intents.intentCreated
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(EditIntent))
);
